const SmsToIcon = (props) => (
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.7389 18.0002L11.5045 13.8095H4.3042C1.93114 13.8095 0 11.8841 0 9.5181V5.26721C0 2.90121 1.93114 0.97583 4.3042 0.97583H15.6958C18.0689 0.97583 20 2.90121 20 5.26721V9.5181C20 11.5089 18.6322 13.2098 16.7389 13.6802V18.0002Z"
      fill="#84E075"
    />
    <path
      d="M9.64387 9.23792L8.47797 10.561C8.36508 10.6892 8.3282 10.8615 8.38299 11.0048C8.43778 11.1482 8.57463 11.2374 8.73543 11.2345L14.82 11.1283C14.9476 11.1264 15.0745 11.0658 15.1641 10.9641C15.2537 10.8624 15.2961 10.7309 15.279 10.6076L14.4728 4.71297C14.4511 4.55952 14.3413 4.44271 14.1896 4.41187C14.038 4.38102 13.871 4.44152 13.7592 4.56781L12.5859 5.89926C12.4254 6.0808 12.1628 6.11746 11.997 5.98149C10.6738 4.90347 7.58819 2.72301 4.38839 5.24525C4.24186 5.36157 4.17409 5.54867 4.21928 5.7121C4.26447 5.87553 4.41279 5.97974 4.58937 5.97213C5.45391 5.94063 6.7002 6.19213 8.12147 7.38445L9.63648 8.65542C9.80182 8.79412 9.80513 9.05492 9.64387 9.23792Z"
      fill="white"
    />
  </svg>
);

export default SmsToIcon;
